import { EventType } from 'rrweb';
import Agent from '.';
import EventBuffer from './eventBuffer';

class Sender {
  agent: Agent;
  eventBuffer: EventBuffer;

  constructor(agent: Agent) {
    this.agent = agent;
    this.eventBuffer = new EventBuffer();
  }

  start() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') this.send();
    });
  }

  handle(event: any) {
    if (
      event.type === EventType.FullSnapshot &&
      this.eventBuffer.find((e) => e.type === EventType.FullSnapshot)
    ) {
      console.warn('Full snapshot already in buffer, ignoring...');
      return;
    }
    this.eventBuffer.push(event);
    if (this.eventBuffer.isFull()) this.send();
  }

  async send() {
    if (this.eventBuffer.isEmpty()) return;

    if (this.agent.sendEvents) {
      const events = this.eventBuffer.flush();
      await this.agent.sendEvents(events);
    } else {
      console.warn('No send function provided to Agent');
    }
  }
}

export default Sender;
